import CloseIcon from '@mui/icons-material/Close';
import { AppBar, styled, Grid, Toolbar, Skeleton, Stack, IconButton } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { WsDialog, WsColors, Item } from 'wisestep-base';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

import CVContentLoader from './CVContentLoader';

const Header = styled(Grid)(() => ({
  backgroundColor: WsColors.TertiaryShades200,
}));

const SkeletonUI = styled(Skeleton)(() => ({
  backgroundColor: WsColors.TertiaryShades100,
}));

const Content = styled(Grid)(() => ({
  height: '90vw',
  overflow: 'auto',
}));

const WidgetLoader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const onWidgetClose = useConversationWidgetStore((state) => state.onWidgetClose);

  const handleClose = () => {
    if (location.pathname.indexOf('/candidate-job-board-profile') > -1) {
      navigate('/home');
    }
    onWidgetClose();
  };

  return (
    <WsDialog openDialog={true} fullScreen={true}>
      <AppBar sx={{ position: 'relative', bgcolor: WsColors.White }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="close">
            <CloseIcon onClick={handleClose} />
          </IconButton>
          <CVContentLoader />
        </Toolbar>
      </AppBar>
      <Content container>
        <Header item md={6} sx={{ overflowY: 'auto', height: '100%' }}>
          <Item>
            <SkeletonUI variant="rectangular" animation="wave" sx={{ m: 2 }} />
          </Item>
        </Header>
        <Grid item md={6} sx={{ overflowY: 'auto', height: '100%' }}>
          <Item>
            <SkeletonUI variant="rectangular" sx={{ m: 2 }} />
            <Stack spacing={1} direction="row" sx={{ m: 2 }}>
              <SkeletonUI animation="wave" variant="rectangular" width={210} height={60} />
              <SkeletonUI animation="wave" variant="rectangular" width={210} height={60} />
            </Stack>
            <SkeletonUI animation="wave" variant="rectangular" height={160} sx={{ m: 2 }} />
            <SkeletonUI animation="wave" variant="rectangular" height={160} sx={{ m: 2 }} />
          </Item>
        </Grid>
      </Content>
    </WsDialog>
  );
};

export default WidgetLoader;
